import { gql } from 'urql';

const GetPlaidAccountRelinkToken = gql`
  query GetRelinkTokenForAccountV2($accountId: ID!) {
    plaidAccountLinkTokenForRelinkV2(input: { accountId: $accountId }) {
      __typename
      ... on PlaidAccountLinkToken {
        linkToken
        linkReferenceId
        expirationDate
      }
      ... on PlaidAccountLinkTokenForRelinkV2Error {
        code
        title
        message
      }
    }
  }
`;

export default GetPlaidAccountRelinkToken;
